import { GeoPressureIntelligenceClient } from "@/components/globe/geo-pressure-intelligence-client";
import { SiteNav } from "@/components/layout/site-nav";
import { useSearchParams } from "react-router-dom";
import {
  getStreamSourceFromSearchParams,
  parseGeoPressureFilters,
  parseGlobeCameraUrlState,
  resolveGlobeStreamSource,
  DEFAULT_GDELT_LIVE_FRAME_URL,
} from "@/lib/gdelt-globe";
import { siteConfigRepository } from "@/repositories/site-config-repository";
import type { GlobeFrame, GlobeMapMode } from "@/types/gdelt";
import mockFrame from "../../../public/mock/gdelt/globe-frame.json";

export default function GlobalPressurePage() {
  const [searchParams] = useSearchParams();
  const params = Object.fromEntries(searchParams.entries());
  const siteConfig = siteConfigRepository.getSiteConfig();
  const source = resolveGlobeStreamSource(getStreamSourceFromSearchParams(params), DEFAULT_GDELT_LIVE_FRAME_URL);

  return (
    <>
      <SiteNav brand={siteConfig.brand} items={siteConfig.navigation} developerItems={siteConfig.developerNavigation} />
      <GeoPressureIntelligenceClient
        initialFrame={mockFrame as GlobeFrame}
        initialFilters={parseGeoPressureFilters(params)}
        initialCameraState={parseGlobeCameraUrlState(params)}
        initialSourceUrl={source.url}
        initialMapMode={getMapMode(params.mode)}
      />
    </>
  );
}

function getMapMode(mode: string | string[] | undefined): GlobeMapMode {
  const value = Array.isArray(mode) ? mode[0] : mode;
  return value === "terrain" ? "terrain" : "outline";
}
